/****************************************************************
 * CODE search init
 ****************************************************************/

$.code.searchInit = function() {
  
  // Init color swatches on collection page
  setInterval(function() {
    $('[data-color-swatch]:not(.color-swatch-handled)').colorSwatch().addClass('color-swatch-handled');
  }, 1000);

};

$.code.searchInit();
